// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "fb89fe21dd32012d739b" + "/js/" + chunkId + ".js";
};